import React from 'react';

const INSCRIPCIONES_FALLARON_PREFIX = /^Existen inscripciones que fallaron:?\s*/i;
const PARTIAL_SUCCESS_FOOTER = ' En las materias no mencionadas';

export function parseMdPageErrorMessage(message) {
  const text = (message || '').trim();
  if (!text) {
    return { title: '', items: [], footer: '' };
  }

  if (!text.includes('|')) {
    return { title: '', items: [text], footer: '' };
  }

  let title = '';
  let rest = text;
  const prefixMatch = rest.match(INSCRIPCIONES_FALLARON_PREFIX);
  if (prefixMatch) {
    title = 'Existen inscripciones que fallaron:';
    rest = rest.slice(prefixMatch[0].length);
  }

  let footer = '';
  const footerIdx = rest.indexOf(PARTIAL_SUCCESS_FOOTER);
  if (footerIdx !== -1) {
    footer = rest.slice(footerIdx).trim();
    rest = rest.slice(0, footerIdx);
  }

  const items = rest.split('|').map((item) => item.trim()).filter(Boolean);
  return { title, items, footer };
}

export function MdPageErrorMessage({ message }) {
  const text = (message || '').trim();
  if (!text) {
    return null;
  }

  const { title, items, footer } = parseMdPageErrorMessage(text);
  const displayItems = items.length ? items : [text];

  if (displayItems.length === 1 && !title && !footer) {
    return (
      <div className="md-page__error-panel" role="alert">
        <p className="md-page__error-panel-text">{displayItems[0]}</p>
      </div>
    );
  }

  return (
    <div className="md-page__error-panel" role="alert">
      {title ? <p className="md-page__error-panel-title">{title}</p> : null}
      <ul className="md-page__error-list">
        {displayItems.map((item) => (
          <li key={item}>{item}</li>
        ))}
      </ul>
      {footer ? <p className="md-page__error-panel-footer">{footer}</p> : null}
    </div>
  );
}
